import React from "react";
import SchedulingService from '@services/graphQLSchedulingService'
import I18n from '@src/i18n'
import { useEffect, useState } from 'react';
import styled from '@src/styled-components'

const Status = ({ userId, setDisable, processType }: any) => {
  const processGraphQL: any = new SchedulingService();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if(processType === 'scheduled')
    loadScheduledStatus()
  }, [])

  const loadScheduledStatus = async () => {
    const { data } = await processGraphQL.getSchedule(userId);
    setStatus(data.getSchedules.status)
  }

  function getStatus(status: any) {
    switch (status) {
      case 1:
        return I18n.l('schedule.filter.PENDENT')
      case 2:
        return I18n.l('schedule.filter.INPROGRESS')
      case 3:
        setDisable(true)
        return I18n.l('schedule.filter.DONE')
      case 5:
        return I18n.l('schedule.filter.OVERDUE')
      default:
        return I18n.l('statusprocess.available')
    }
  }
  return <>
      <Wrapper>Status: {status ? getStatus(status) : (processType === 'unscheduled' ? I18n.l('statusprocess.available') : I18n.l('common.loadingProcesses'))}</Wrapper>
      <div>{status === 3 ? I18n.l('schedule.filter.DONE_BLOCKED') : ''}</div>
      </>
}
export default Status;

const Wrapper = styled.div`
  font-weight: bold;
`;